import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext } from "react"
import { AppContext } from "Views/Home/context"
import { CalendarContext } from "./context"
import cal from "clsx"
import { User } from "Types/user"
import { AdPlace } from "Types/place"
import { BoardAction, BoardModifyDialog } from "Types/board"
import { useMouseGesture } from "Hooks/basic"
import { useUpdateBoardTime, useUpdateWeChatBoardTime, useUpdateSpeciesBoardTime, useUpdateEatBoardTime, useUpdateHealthBoardTime } from "Hooks/board"
import { InitialModal } from "Methods/modal"

const useStyles = makeStyles(() => ({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
        transition: "all ease .3",
    },
    move: {
        transition: "all ease .3",
    },
    moveBoard: {
        color: "white",
        backgroundColor: "#999",
        position: "absolute",
        width: "90%",
        borderRadius: 6,
        right: 4,
        top: 4,
        zIndex: 1,
        padding: "0 20px 0 10px",
        height: 40,
        wordBreak: "break-word",
    },
}))

interface ComponentProps {
    place: AdPlace,
    date: Date,
}

export function checkWeiboAdPlace(user: User, place: AdPlace) {
    // 点位运营只能预约微博的15：00和19：00
    const enableAdPlace = ["15：00", "19：00"]
    const { role } = user || {}
    const { name } = role || {}
    const { name: placeName } = place
    if (name === "点位运营" && enableAdPlace.indexOf(placeName) === -1) {
        return false
    } else {
        return true
    }
}

const createTypes: { [any: string]: BoardAction } = {
    '微博': 'weibo_create',
    '微信': 'wechat_create',
    '童学馆': 'child_create',
    '果壳视频': 'video_create',
    '摄影': 'photo_create',
    '美丽': 'beauty_create',
    '果壳自然': 'species_create',
    '吃货': 'eat_create',
    '果壳病人': 'health_create',
}

const EmptyItem = (props: ComponentProps) => {
    const { place, date } = props
    const classes = useStyles()
    const {
        privilege, handleChangeBoardModifyDialog, boardModifyDialog,
        isWeChat, isWeibo, movableBoard,
        channelName, isSpecies, isHealth,
    } = useContext(CalendarContext)
    const { show, handleMouseEnter, handleMouseLeave } = useMouseGesture()
    const { handleChangeModal, user } = useContext(AppContext)
    const { updateTime } = useUpdateWeChatBoardTime()
    const { update } = useUpdateBoardTime()
    const { updateSpeciesTime } = useUpdateSpeciesBoardTime()
    const { updateHealthTime } = useUpdateHealthBoardTime()
    const { updateEatTime } = useUpdateEatBoardTime()
    const isPass = new Date().getTime() - (24 * 3600 * 1000) > date.getTime()
    const { role } = user || {}
    const { role_name } = role || {}
    const isTrueEditor = role_name === "true_editor"
    const isSideEditor = role_name === 'side_editor'
    const handleAddBoard = () => {
        if (channelName === '美丽') return BeautyAdd()
        if (channelName === '童学馆') return childrenAdd()
        if (channelName === '果壳视频') return videoAdd()
        if (channelName === '摄影') return photoAdd()
        if (channelName === '果壳自然') return speciesAdd()
        if (channelName === '吃货') return eatAdd()
        if (channelName === '果壳病人') return healthAdd()
        // 编辑部主编可新增过期预约内容
        if (!privilege.insert || (isPass && !isTrueEditor)) {
            return
        }
        if (isWeibo && !checkWeiboAdPlace(user, place)) {
            return
        }
        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }

    const childrenAdd = () => {
        // 编辑部主编可新增过期预约内容

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        if (isPass) return
        if (
            (
                ['children', 'marketing', 'business', 'video'].indexOf(type_name) < 0
                || ['user', 'side_editor'].indexOf(role_name) < 0
            )
            // 电商内容 编辑部编辑 日历所有人预约的增删改查
            && (role_name !== 'side_editor' && type_name !== 'newmedia')
        ) return

        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }
    const speciesAdd = () => {
        // 编辑部主编可新增过期预约内容

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        if (isPass) return
        // 权限taiga http://taiga.iguokr.com/project/liyang-noah/us/2410
        // 指定部门与管理员可进行操作
        const isAuthenticatedPartment = ['editor', 'business', 'market', 'science', 'lamp', 'datamuse', 'newmedia', 'video', 'marketing', 'children', 'coffee', 'om', 'finance', 'nuts'].includes(type_name)
        const isAdmin = role_name === 'admin'
        if (!isAdmin && !isAuthenticatedPartment) return
        // 指定部门点位运营及编辑，均可添加日历，其余角色只可查看日历
        if (['user', 'side_editor', 'true_editor'].indexOf(role_name) < 0) return

        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }
    const healthAdd = () => {
        // 编辑部主编可新增过期预约内容

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        if (isPass) return
        // 权限taiga http://taiga.iguokr.com/project/liyang-noah/us/2410
        // 指定部门与管理员可进行操作
        const isAuthenticatedPartment = ['editor', 'business', 'market', 'science', 'lamp', 'datamuse', 'newmedia', 'video', 'marketing', 'children', 'coffee', 'om', 'finance', 'nuts'].includes(type_name)
        const isAdmin = role_name === 'admin'
        if (!isAdmin && !isAuthenticatedPartment) return
        // 指定部门点位运营及编辑，均可添加日历，其余角色只可查看日历
        if (['user', 'side_editor', 'true_editor'].indexOf(role_name) < 0) return

        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }
    const eatAdd = () => {
        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        if (isPass) return
        // https://taiga.iguokr.com/project/yan-fa-shi-yan-shi/us/1224?milestone=627
        // 电商内容-编辑部编辑，商务部\营销部\视频部-点位运营 可进行添加
        // 其余角色只可查看日历
        const isSideEditor = type_name === 'newmedia' && role_name === 'side_editor'
        const isUser = ['business', 'video', 'marketing'].includes(type_name) && role_name === 'user'

        if (!isSideEditor && !isUser) return
        // const isEatPartment = ['eat'].includes(type_name)
        // if (!isEatPartment || !['user', 'side_editor'].includes(role_name)) return

        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }
    const BeautyAdd = () => {
        // 编辑部主编可新增过期预约内容
        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        if (isPass) return
        // 营销部点位运营可添加点位
        if (
            (
                !['beauty', 'marketing'].includes(type_name)
                || !['side_editor', 'user'].includes(role_name)
            )
            // 电商内容 编辑部编辑 日历所有人预约的增删改查
            && (role_name !== 'side_editor' && type_name !== 'newmedia')
        ) return

        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }

    const videoAdd = () => {
        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        if (isPass) return
        if (['video', 'business'].indexOf(type_name) < 0 || ['user'].indexOf(role_name) < 0) return

        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }

    const photoAdd = () => {
        // 编辑部主编可新增过期预约内容

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        if (isPass) return
        if (['user', 'photoer'].indexOf(role_name) < 0) return

        const type: BoardAction = createTypes[channelName] || "create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            place,
            date,
            type,
        })
    }
    const isMoving = movableBoard !== null && movableBoard.id
    let showText = ""
    let style = {}
    if (isMoving) {
        const { article_type, name = "", author, description } = movableBoard || {}
        const { color_code: color } = article_type || {}
        showText = name
        style = {
            backgroundColor: color,
        }
        if (isWeChat) {
            showText = `${author ? `【${author.name}】` : ""}${description}`
        }
    }
    const handleEndMove = async () => {
        // 编辑部主编可移动过期预约内容
        if (
            (!isSpecies && channelName !== '吃货' && !isHealth && (!privilege.insert || (isPass && !isTrueEditor)))
            || (isSpecies && ((isPass && !isTrueEditor)))
            || (isHealth && !isTrueEditor && !isSideEditor)
        ) {
            return
        }
        if (movableBoard && movableBoard.id) {
            try {
                switch (channelName) {
                    case '微信':
                        await updateTime(
                            movableBoard.id, {
                            ad_time: date,
                            seq_id: place.id,
                            description: movableBoard.description,
                            author_id: movableBoard.author_id,
                            article_type_id: movableBoard.article_type_id,
                            is_draft: false,
                        })
                        break
                    case '微博':
                        await update({
                            variables: {
                                id: movableBoard.id,
                                ad_place_id: place.id,
                                ad_time: date,
                                is_draft: false,
                            },
                        })
                        break
                    case '吃货':
                        await updateEatTime({
                            variables: {
                                is_draft: false,
                                id: movableBoard.id,
                                ad_time: date,
                                ad_place_id: place._id,
                                seq_id: place.id,
                            }
                        })
                        break
                    case '果壳自然':
                        await updateSpeciesTime({
                           variables: {
                               is_draft: false,
                               id: movableBoard.id,
                               ad_time: date,
                               ad_place_id: place._id,
                               seq_id: place.id,
                           },
                        })
                        break
                    default:
                        await updateHealthTime({
                            variables: {
                                is_draft: false,
                                id: movableBoard.id,
                                ad_time: date,
                                ad_place_id: place._id,
                                seq_id: place.id,
                            },
                         })
                        break

                }
                handleChangeModal({
                    show: true,
                    type: "success",
                    title: "已修改！",
                    timeout: 1200,
                    customButtons: [],
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
            } catch (err) {
                if (!navigator.onLine) {
                    handleChangeModal({
                        show: true,
                        type: "warning",
                        customButtons: [],
                        title: "oops! 断网啦！",
                        timeout: 3000,
                        onConfirm: () => {
                            handleChangeModal(InitialModal)
                        },
                    })
                    return
                }
                const { response: { data = {} } = {}, message } = (err as any)
                handleChangeModal({
                    show: true,
                    type: "warning",
                    customButtons: [],
                    title: data.message || message,
                    timeout: 3000,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
            }
        }
    }
    return (
        <div
            className={
                cal(
                    classes.root,
                    show && isMoving && classes.move,
                )
            }
            onClick={handleAddBoard}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleEndMove}
        >
            {
                show && isMoving && (
                    <div className={classes.moveBoard} style={style}>
                        {showText}
                    </div>
                )
            }
        </div>
    )
}

export default EmptyItem
